import { useLocalStorage } from '@vueuse/core'

export const useCustomizationStore = defineStore('customization', () => {
  const step = ref('choose-mode')
  const formMode = ref(null)
  const createMode = ref('manual')
  const isEditing = ref(false)
  const modelToEdit = ref(null)

  // Variável para controlar se veio do modal de aplicação
  const cameFromModelApplyer = ref(false)

  const customizedPromptsTemp = useLocalStorage(
    `customized-prompts-temp-${window.tokenParsed.sub}`,
    [],
  )

  const addCustomSpecialty = (customPrompt) => {
    customizedPromptsTemp.value.push(customPrompt)
  }

  const removeCustomSpecialty = (specialtyValue) => {
    customizedPromptsTemp.value = customizedPromptsTemp.value.filter(
      (specialty) => specialty.value !== specialtyValue,
    )
  }

  return {
    customizedPromptsTemp,
    step,
    formMode,
    createMode,
    isEditing,
    modelToEdit,
    cameFromModelApplyer,
    addCustomSpecialty,
    removeCustomSpecialty,
  }
})
